export const formatDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('id-ID');
};

export const normalizeErrorMessage = (error) => {
  if (!error) return 'Terjadi kesalahan';
  if (typeof error === 'string') return error;
  if (error?.message) return String(error.message);
  return 'Terjadi kesalahan';
};

export const statusColorClass = (status) => {
  const key = String(status || '').toUpperCase();
  if (key === 'ACTIVE' || key === 'SUCCESS') return 'bg-emerald-500/20 text-emerald-300 border-emerald-400/40';
  if (key === 'FAILED' || key === 'REVOKED' || key === 'DISABLED') return 'bg-red-500/20 text-red-300 border-red-400/40';
  return 'bg-amber-500/20 text-amber-300 border-amber-400/40';
};
